import { NgModule } from '@angular/core';
import { provideConfig } from '../../../core/config/config-providers';

/**
 * Subscription billing endpoints (FTE documentation/subscription-billing.md).
 * BILLING_VIEW reads, BILLING_MANAGE changes; FTE also requires the request
 * profile to be `freely` or the billing merchant profile.
 */
@NgModule({
  providers: [
    provideConfig({
      api: {
        endpoints: {
          adminBillingSettings: 'admin/billing/settings',
          adminBillingDistributors: 'admin/billing/distributors',
          adminBillingAccounts: 'admin/billing/accounts',
          adminBillingAccount: 'admin/billing/accounts/${accountId}',
          adminBillingPlans: 'admin/billing/plans',
          adminBillingPlan: 'admin/billing/plans/${planId}',
          adminBillingSubscriptions: 'admin/billing/subscriptions',
          adminBillingSubscription: 'admin/billing/subscriptions/${subscriptionId}',
          adminBillingSubscriptionPrice: 'admin/billing/subscriptions/${subscriptionId}/price',
          adminBillingSubscriptionCancel: 'admin/billing/subscriptions/${subscriptionId}/cancel',
          adminBillingRun: 'admin/billing/run',
        },
      },
    }),
  ],
})
export class ConfigModule {}
